/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentCandidate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import Selected from './Selected/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function AppointmentCandidate({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/AppointmentCandidate"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let timegridValueData = fromData.useDataFormat({ viewPath,
context: 'timegrid',
format: fromHelpers.displayZoomIn,
})
let eventSelectedValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'selected',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsGreen700alpha50 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.50'
        })
let dtColorsGreen700alpha40 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.40'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<button
  data-testid="AppointmentCandidate.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-1-qwWsQ': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-2-qwWsQ': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btlr-3-qwWsQ': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-4-qwWsQ': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bc-5-qwWsQ': dtColorsGreen700alpha50,'--c-6-qwWsQ': timegridValueData ? "zoom-in" : "pointer",'--bc-7-qwWsQ': eventSelectedValueData ? dtColorsGreen700 : dtColorsGreen700alpha40}}
 className={`views-block ${styles.Vertical}`}
>
<Selected
  viewPath={`${viewPath}/Selected`}
/>
</button>
{children}
</React.Fragment>)
}